(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bn-product-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bn-product-contents')) {
  customElements.define('bn-product-contents', class extends HTMLElement {
    connectedCallback() {
      this.onVariantChange = (event) => {
        const picker = event.target.closest?.('variant-picker');
        if (!picker || picker.dataset.productId !== this.dataset.productId) return;
        const selected = picker.querySelector('input:checked[data-variant-id]');
        const content = selected && this.querySelector('template[data-bn-variant="' + selected.dataset.variantId + '"]');
        const target = this.querySelector('[data-bn-copy]');
        if (content && target) target.replaceChildren(content.content.cloneNode(true));
      };
      document.addEventListener('change', this.onVariantChange);
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
